<div matDialogTitle
     class="nuget-versions-modal-title-container text-ellipsis">
    <p *ngIf="!selectedPackageVersion"
       [translateParams]="{
               packageName: context.data.id
           }"
       [translate]
       class="version-title">
        packages_versions_modal_title
    </p>
    <button [matTooltip]="'package_versions_back_arrow' | translate"
            [style.display]="!selectedPackageVersion ? 'none' : ''"
            (click)="showVersions()"
            class="back-button"
            mat-icon-button
            data-cy="nuget-changelog-back"
            type="button">
        <mat-icon>arrow_back</mat-icon>
    </button>
    <p *ngIf="!!selectedPackageVersion &&
              currentPackageVersionViewMode === PackageVersionViewMode.Arguments"
       [translateParams]="{
                            packageName: context.data.id,
                            version: selectedPackageVersion.version
                        }"
       translate>
        package_version_arguments_title
    </p>
    <p *ngIf="!!selectedPackageVersion &&
              currentPackageVersionViewMode === PackageVersionViewMode.ReleaseNotes"
       [translateParams]="{
                            packageName: context.data.id,
                            version: selectedPackageVersion.version
                        }"
       translate>
        package_version_release_notes_title
    </p>
</div>

<mat-dialog-content class="nuget-versions-modal-container">
    <mat-tab-group [hidden]="!!selectedPackageVersion">
        <mat-tab #versionsTab
                 [label]="'package_versions_modal_versions_tab' | translate">
        </mat-tab>
        <mat-tab #changelogTab
                 [label]="'package_versions_modal_change_log_tab' | translate">
        </mat-tab>
    </mat-tab-group>

    <div [hidden]="!versionsTab.isActive">
        <ui-nuget-versions-grid [hidden]="!!selectedPackageVersion"
                                [nugetService]="nugetService"
                                [type]="context.additionalData.type"
                                [deletePermission]="deletePermission"
                                [packageId]="context.data.id"
                                (close)="onClose($event)"
                                (showInformation)="showInformation($event, PackageVersionViewMode.Arguments)"
                                (showReleaseNotes)="showInformation($event, PackageVersionViewMode.ReleaseNotes)"
                                (latestVersions)="latestVersions = $event"
                                data-cy="nuget-version-grid-container">
        </ui-nuget-versions-grid>
    </div>

    <div [hidden]="!changelogTab.isActive">
        <ui-nuget-changelog-list [hidden]="!!selectedPackageVersion"
                                 [nugetService]="nugetService"
                                 [latestVersions]="latestVersions"
                                 [type]="context.additionalData.type"
                                 [packageId]="context.data.id">
        </ui-nuget-changelog-list>
    </div>

    <ui-process-io-parameters *ngIf="!!selectedPackageVersion &&
                                     currentPackageVersionViewMode === PackageVersionViewMode.Arguments"
                              [args]="selectedPackageVersion?.arguments">
    </ui-process-io-parameters>

    <ui-nuget-changelog *ngIf="!!selectedPackageVersion &&
                               currentPackageVersionViewMode === PackageVersionViewMode.ReleaseNotes"
                        [package]="selectedPackageVersion"
                        [type]="context.additionalData.type"
                        [isDownloadEnabled]="isDownloadEnabled"
                        [downloadLink]="downloadLink(selectedPackageVersion)">
    </ui-nuget-changelog>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-dialog-close
            mat-button
            type="button"
            data-cy="nuget-version-close">
        {{ 'modal_action_close' | translate }}
    </button>
</mat-dialog-actions>
